import gql from "graphql-tag";

import { fragments as deviceFraudCommentsFragments } from "./Fragment.FraudCommentsParts";

export const susDeviceCommentsQuery = gql`
  ${deviceFraudCommentsFragments.fraudCommentsParts}

  query susDeviceCommentsQuery($deviceExternalReference: ID!) {
    devices(external_reference: $deviceExternalReference) {
      external_reference
      ...FraudCommentsParts
    }
  }
`;
